/* eslint-disable max-len */
/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2025 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for ManageRosterIcon
 *
 * @author Anuja Gaikwad
*/

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ManageRosterIcon(props) {
  return (
    <SvgIcon {...props} width="18" height="17" viewBox="0 0 18 17">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 8.625C8.678 8.625 10.3633 9.66427 11.2761 11.2132C11.9311 10.8387 12.6906 10.625 13.5 10.625C15.9853 10.625 18 12.6397 18 15.125V15.625C18 16.1773 17.5523 16.625 17 16.625H1C0.447715 16.625 0 16.1773 0 15.625V13.875C0 10.9755 2.35051 8.625 5.25 8.625H6.75ZM13.5 12.375L13.2792 12.3837C12.7695 12.4242 12.299 12.6038 11.9067 12.8845C11.9526 13.125 11.9821 13.3715 11.994 13.6225L12 13.875L11.9997 14.875H16.237L16.2301 14.7926L16.2044 14.6237C15.9894 13.4561 15.0367 12.5467 13.8476 12.3968L13.6675 12.38L13.5 12.375ZM6.75 10.375H5.25C3.38144 10.375 1.85487 11.8393 1.75518 13.683L1.75 13.875V14.875H10.25V13.875C10.25 12.0064 8.78572 10.4799 6.94204 10.3802L6.75 10.375ZM13.5 3.75C15.1569 3.75 16.5 5.09315 16.5 6.75C16.5 8.40685 15.1569 9.75 13.5 9.75C11.8431 9.75 10.5 8.40685 10.5 6.75C10.5 5.09315 11.8431 3.75 13.5 3.75ZM13.5 5.5C12.8096 5.5 12.25 6.05964 12.25 6.75C12.25 7.44036 12.8096 8 13.5 8C14.1904 8 14.75 7.44036 14.75 6.75C14.75 6.05964 14.1904 5.5 13.5 5.5ZM6 0C8.07107 0 9.75 1.67893 9.75 3.75C9.75 5.82107 8.07107 7.5 6 7.5C3.92893 7.5 2.25 5.82107 2.25 3.75C2.25 1.67893 3.92893 0 6 0ZM6 1.75C4.89543 1.75 4 2.64543 4 3.75C4 4.85457 4.89543 5.75 6 5.75C7.10457 5.75 8 4.85457 8 3.75C8 2.64543 7.10457 1.75 6 1.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
